import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IBlankslate } from 'codex-lib';
import { Signatory } from '../model/signatory';
import { CheckboxState } from 'src/app/enum/checkbox-state';
import { StringUtil } from 'src/app/util/string-util';
import { NewEnvelopeService } from '../new-envelope/new-envelope.service';
import { LanguageUtil } from 'src/app/util/language-util';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-signatory-table',
  templateUrl: './signatory-table.component.html',
  styleUrls: ['./signatory-table.component.scss']
})
export class SignatoryTableComponent implements OnInit {
  @Output() checkAllClick = new EventEmitter();
  @Output() elementClick = new EventEmitter();
  @Output() cleanSearchClick = new EventEmitter();

  @Input() elements: Array<Signatory>;
  @Input() headerCheckboxState: CheckboxState;
  blankslateOptions: IBlankslate;
  checkboxState = CheckboxState;

  hiddenSSNColumn = false;
  hiddenPhoneColumn = false;

  constructor(
    private newEnvelopeService: NewEnvelopeService,
    private authService: AuthService,) {
    if (!this.authService.signUserModel) {
      return;
    }

    this.hiddenPhoneColumn = !this.authService.signUserModel.sendWhatsapp;
  }

  checkLanguageEnvelope(language) {
    if (!LanguageUtil.isCurrentLanguagePT(language)) {
      this.hiddenSSNColumn = true;
    }
  }

  ngOnInit() {
    this.checkLanguageEnvelope(this.newEnvelopeService.getLanguageEnvelope());
    this.blankslateOptions = {
      icon: {
        prefix: 'fad',
        iconName: 'search-minus'
      },
      buttonText: 'cleanSearch'
    };
  }

  onHeaderCheckboxChange() {
    this.checkAllClick.emit();
  }

  onCheckboxClick(el) {
    this.elementClick.emit(el);
  }

  onBlankSlateButtonClick() {
    this.cleanSearchClick.emit();
  }

  isNilOrEmpty(str: string): boolean {
    return StringUtil.isNullOrEmpty(str);
  }

  setMaskValue(value) {
    return CPFCNPJUtil.formatSsn(value);
  }
}
